import styled from 'styled-components'

import { Button, Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  background-color: ${props => props.theme.colors.success.surface};
  border-radius: ${props => props.theme.spacing.sp4};
  padding: ${props => props.theme.spacing.sp16};
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  margin-top: ${props => props.theme.spacing.sp8};
  margin-bottom: ${props => props.theme.spacing.sp8};
`

export const IconContainer = styled.div`
  color: ${props => props.theme.colors.outline.default};
`

export const TextContainer = styled.div`
  flex: 1;
`

export const StyledButton = styled(Button)`
  height: 1.5rem;
`

export const StyledText = styled(Text)`
  line-height: 1rem !important;
`
